import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
// import Uutuudet from "../images/uutuudet.svg";
// import Tarjoukset from "../images/tarjoukset.svg";
import MainCarousel from "./MainCarousel";
import ProductsLanding from "./ProductsLanding";

import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../actions/types";

class Landing extends Component {
  state = {
    newProducts: [],
    etusivu: "",
  };
  async componentDidMount() {
    const newProducts = await axios.get(`${BASE_URL}/getNewProducts`);
    this.setState({ newProducts: newProducts.data });
    const ajankohtaista = await axios.get(`${BASE_URL}/etusivu`);
    this.setState({ etusivu: ajankohtaista.data });
  }

  //   <Container>
  //   <Row className="margin">
  //     <Col>
  //       <img
  //         className="centerImage"
  //         src={Tarjoukset}
  //         alt=""
  //         height="40"
  //       />
  //     </Col>
  //   </Row>
  //   <Row>
  //     <ProductsLanding {...uutuudet} />
  //   </Row>
  // </Container>

  render() {
    let ajankohtaista = <div />;

    if (this.state.etusivu) {
      ajankohtaista = (
        <Row>
          <Col style={{ textAlign: "center" }}>
            <h2>Ajankohtaista</h2>
            <p>
              <b>{this.state.etusivu}</b>
            </p>
          </Col>
        </Row>
      );
    }

    console.log(this.state);
    return (
      <div>
        <Container fluid className="carousel">
          <Row>
            <Col>
              <MainCarousel />
            </Col>
          </Row>
        </Container>

        <Container>
          {ajankohtaista}
          <Row className="margin">
            <Col>
              <img
                className="centerImage"
                src={`${IMAGE_URL}/uutuudet.png`}
                alt=""
                style={{ height: "50px", width: "auto" }}
              />
            </Col>
          </Row>
          <Row>
            <ProductsLanding {...this.state.newProducts} />
          </Row>
        </Container>
      </div>
    );
  }
}

export default React.memo(Landing);
